const roles = {
  ADMIN: 'Admin',
  USER: 'User',
  TEACHER: 'Teacher'
}

export default roles